import { render, staticRenderFns } from "./Accordian.vue?vue&type=template&id=53babd89&scoped=true"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"
import style0 from "./Accordian.vue?vue&type=style&index=0&id=53babd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53babd89",
  null
  
)

export default component.exports